module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('main-nav', {
    attrs: {
      "mobile": _vm.cards_mobile_active
    }
  }), _vm._v(" "), _c('div', {
    class: {
      card_active: _vm.card_active
    },
    attrs: {
      "id": "site_wrap"
    }
  }, [_c('img', {
    attrs: {
      "id": "intro_animation",
      "src": require("./assets/img/intro_animation.gif")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "id": "intro_animation_mobile",
      "src": require("./assets/img/intro_animation_mobile.gif")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "landing_intro"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "large",
    attrs: {
      "id": "landing_intro_text"
    }
  }, [_vm._v("Ready or not, summer is here. The season we dream about all through childhood has much more than sunshine and sand to offer. We're giving you something fun to try every day, so spend your summer with us!")]), _vm._v(" "), _c('img', {
    attrs: {
      "id": "landing_intro_chevron",
      "src": require("./assets/img/chevron_down.svg")
    },
    on: {
      "click": _vm.scroll_to_grid
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "id": "open_cards_mobile"
    },
    on: {
      "click": function($event) {
        _vm.cards_mobile_active = true
      }
    }
  }, [_vm._v("let's go!")])])])]), _vm._v(" "), _c('card-grid', {
    attrs: {
      "cards": _vm.cards
    },
    on: {
      "cardopen": _vm.set_active
    }
  }), _vm._v(" "), _c('cards-mobile', {
    attrs: {
      "cards": _vm.cards,
      "active": _vm.cards_mobile_active
    }
  })], 1), _vm._v(" "), _c('router-view', {
    on: {
      "cardopen": _vm.set_active
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fc70d4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 48
// module chunks = 0